class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
    const endlessCollection = new Ajaxinate({
      container: "#product-grid",
      pagination: ".infinite_next",
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

window.onload = function () {
  console.log("hello");

  const facetForm = document.querySelector(".facets-vertical-form");
  console.log(facetForm);

  const facetWrapper = document.querySelector(".facets-wrapper");
  const productCountElement = document.querySelector("#ProductCountDesktop");

  if (facetWrapper && productCountElement) {
    const productCount = parseInt(productCountElement.textContent.trim(), 10);

    if (productCount === 0) {
      facetWrapper.style.display = "none";
      console.log("No products found, hiding facets-wrapper.");
    }
  }
};
// orginal code
// function processFacets() {
//   document.querySelectorAll(".facets__summary-label").forEach((label) => {
//     let parentDetails = label.closest("details");
//     if (!parentDetails) return;
//     let summary = label.closest(".facets__summary");
//     let facetsDisplay = parentDetails.closest(".facets__display-vertical");
//     let firstOption = parentDetails.querySelector(
//       ".facet-checkbox__text-label"
//     );

//     if (firstOption) {
//       let labelText = label.textContent
//         .trim()
//         .replace(/\(\d+\)/g, "")
//         .trim();
//       let optionText = firstOption.textContent.trim();

//       if (labelText === optionText) {
//         label.style.display = "none";

//         let icon = label.closest("summary")?.querySelector("svg, .icon-class");
//         if (icon) icon.style.display = "none";

//         parentDetails.setAttribute("open", "true");

//         if (facetsDisplay) facetsDisplay.classList.add("no-bottom-padding");
//         if (summary) summary.classList.add("no-padding");
//       }
//     }
//   });

//   document.querySelectorAll(`[id^="Facet-"]`).forEach((filterElement) => {
//     let parentDetails = filterElement.closest("details");
//     if (!parentDetails) return;

//     let hideLabelIcon = parentDetails.querySelector(".facets__summary-label");
//     if (hideLabelIcon?.style.display === "none") {
//       filterElement.querySelectorAll("li").forEach((item, index) => {
//         if (index !== 0) item.style.display = "none";
//       });
//     }
//   });
// }

function processFacets() {
  document.querySelectorAll(".facets__summary-label").forEach((label) => {
    let parentDetails = label.closest("details");
    if (!parentDetails) return;
    let summary = label.closest(".facets__summary");
    let facetsDisplay = parentDetails.closest(".facets__display-vertical");
    let facetsWrap = parentDetails.closest(".facets-wrap-vertical");
    let facetsDisclosure = parentDetails.closest(
      ".facets__disclosure-vertical"
    );
    let firstOption = parentDetails.querySelector(
      ".facet-checkbox__text-label"
    );

    if (firstOption) {
      let labelText = label.textContent
        .trim()
        .replace(/\(\d+\)/g, "")
        .trim();
      let optionText = firstOption.textContent.trim();

      if (labelText === optionText) {
        label.style.display = "none";

        let icon = label.closest("summary")?.querySelector("svg, .icon-class");
        if (icon) icon.style.display = "none";

        parentDetails.setAttribute("open", "true");

        if (facetsWrap) facetsWrap.classList.add("no-padding");
        if (facetsDisplay) facetsDisplay.classList.add("no-padding");
        if (facetsDisclosure) facetsDisclosure.classList.add("no-border"); // If needed
        if (summary) summary.classList.add("no-padding");
      }
    }
  });

  document.querySelectorAll(`[id^="Facet-"]`).forEach((filterElement) => {
    let parentDetails = filterElement.closest("details");
    if (!parentDetails) return;

    let hideLabelIcon = parentDetails.querySelector(".facets__summary-label");
    if (hideLabelIcon?.style.display === "none") {
      filterElement.querySelectorAll("li").forEach((item, index) => {
        if (index !== 0) item.style.display = "none";
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", processFacets);

new MutationObserver(processFacets).observe(document.body, {
  childList: true,
  subtree: true,
});

function mobileprocessFacets() {
  document.querySelectorAll(".mobile-facets__details").forEach((facet) => {
    const labelSpan = facet.querySelector(
      ".mobile-facets__summary span:first-child"
    );
    const firstOption = facet.querySelector(".facet-checkbox__text-label");
    const summary = facet.querySelector(".mobile-facets__summary");

    if (
      labelSpan &&
      firstOption &&
      labelSpan.textContent.trim() === firstOption.textContent.trim()
    ) {
      labelSpan.style.display = "none";
      const icon = facet.querySelector(".mobile-facets__arrow");
      if (icon) icon.style.display = "none";

      facet.setAttribute("open", "true");

      const listItems = facet.querySelectorAll(".mobile-facets__item");
      listItems.forEach((item, index) => {
        if (index !== 0) {
          item.style.display = "none";
        }
      });

      if (summary) summary.classList.add("no-padding");

      facet.addEventListener("change", function () {
        listItems.forEach((item, index) => {
          if (index !== 0) {
            item.style.display = "none";
          }
        });
      });
    } else {
      if (summary) summary.classList.remove("no-padding");
    }
  });
}

document.addEventListener("DOMContentLoaded", mobileprocessFacets);

const filterContainer = document.querySelector(".mobile-facets__wrapper");
if (filterContainer) {
  const observer = new MutationObserver(() => {
    mobileprocessFacets();
  });

  observer.observe(filterContainer, { childList: true, subtree: true });
}

document.addEventListener("ajax:complete", mobileprocessFacets);
document.addEventListener("filter:updated", mobileprocessFacets);

//************************  Code for the Filter to club all the booleans filters in a Dropdown****************//
function handleDesktopFacets() {
  // Desktop Filters Logic
  const openFacets = document.querySelectorAll(
    '.facets__disclosure-vertical[open="true"]'
  );

  if (openFacets.length > 0) {
    const additionalFilters = document.createElement("details");
    additionalFilters.setAttribute("class", "facets__disclosure-vertical");
    additionalFilters.setAttribute("open", "true");

    const summary = document.createElement("summary");
    summary.classList.add("facets__summary", "caption-large", "focus-offset");
    summary.setAttribute("aria-label", "Additional Filters");
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", "true");

    const divWrapper = document.createElement("div");

    const spanLabel = document.createElement("span");
    spanLabel.classList.add("facets__summary-label");
    spanLabel.innerText = "Additional Filters";

    const svgCaret = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    svgCaret.setAttribute("class", "icon icon-caret");
    svgCaret.setAttribute("viewBox", "0 0 10 6");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("fill", "currentColor");
    path.setAttribute("fill-rule", "evenodd");
    path.setAttribute(
      "d",
      "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
    );
    path.setAttribute("clip-rule", "evenodd");

    svgCaret.appendChild(path);
    divWrapper.appendChild(spanLabel);
    divWrapper.appendChild(svgCaret);
    summary.appendChild(divWrapper);

    additionalFilters.appendChild(summary);

    openFacets.forEach((element) => {
      additionalFilters.appendChild(element);
    });

    const filterContainer = document.querySelector("#FacetFiltersForm");
    if (filterContainer) {
      filterContainer.appendChild(additionalFilters);
    }
  }
}
// sangram code
// function handleMobileFacets() {
//   // if (window.innerWidth <= 749) {
//   console.log("Running handleMobileFacets");

//   const openMobileFacets = document.querySelectorAll(
//     '.mobile-facets__details[open="true"]'
//   );
//   console.log("mobile", openMobileFacets);

//   if (openMobileFacets.length > 0) {
//     const existingAdditionalFilters = document.querySelector(
//       "#Details-Mobile-additional-filters"
//     );

//     if (existingAdditionalFilters) {
//       return;
//     }
//     const additionalFilters = document.createElement("details");
//     additionalFilters.setAttribute("id", "Details-Mobile-additional-filters");
//     additionalFilters.setAttribute("class", "mobile-facets__details js-filter");
//     additionalFilters.setAttribute("data-index", "mobile-additional");

//     const summary = document.createElement("summary");
//     summary.setAttribute("class", "mobile-facets__summary focus-inset");
//     summary.setAttribute("role", "button");
//     summary.setAttribute("aria-expanded", "false");
//     summary.setAttribute("aria-controls", "FacetMobile-additional");

//     const divWrapper = document.createElement("div");

//     const spanLabel = document.createElement("span");
//     spanLabel.innerText = "Additional Filters";

//     const spanArrow = document.createElement("span");
//     spanArrow.setAttribute("class", "mobile-facets__arrow");

//     const svgCaret = document.createElementNS(
//       "http://www.w3.org/2000/svg",
//       "svg"
//     );
//     svgCaret.setAttribute("class", "icon icon-caret");
//     svgCaret.setAttribute("viewBox", "0 0 10 6");

//     const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
//     path.setAttribute("fill", "currentColor");
//     path.setAttribute("fill-rule", "evenodd");
//     path.setAttribute(
//       "d",
//       "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
//     );
//     path.setAttribute("clip-rule", "evenodd");

//     svgCaret.appendChild(path);
//     spanArrow.appendChild(svgCaret);
//     divWrapper.appendChild(spanLabel);
//     divWrapper.appendChild(spanArrow);
//     summary.appendChild(divWrapper);
//     additionalFilters.appendChild(summary);

//     const contentDiv = document.createElement("div");
//     contentDiv.setAttribute("id", "FacetMobile-additional");
//     contentDiv.setAttribute("class", "mobile-facets__submenu gradient");

//     openMobileFacets.forEach((element) => {
//       contentDiv.appendChild(element);
//     });

//     additionalFilters.appendChild(contentDiv);

//     const mobileFilterContainer = document.querySelector(
//       "#FacetsWrapperMobile"
//     );
//     if (mobileFilterContainer) {
//       const childNodes = mobileFilterContainer.childNodes;
//       if (childNodes.length >= 3) {
//         // Insert before the third-to-last element
//         mobileFilterContainer.insertBefore(
//           additionalFilters,
//           childNodes[childNodes.length - 3]
//         );
//       } else {
//         // If there are fewer than 3 children, append at the end
//         mobileFilterContainer.appendChild(additionalFilters);
//       }
//     }
//   }
//   // }
// }

//code working only icon issue
// function handleMobileFacets() {
//   console.log("Running handleMobileFacets");

//   const openMobileFacets = document.querySelectorAll(
//     '.mobile-facets__details[open="true"]'
//   );
//   console.log("Found open mobile facets:", openMobileFacets.length);

//   if (openMobileFacets.length > 0) {
//     const mobileFilterContainer = document.querySelector(
//       "#FacetsWrapperMobile"
//     );

//     if (mobileFilterContainer) {
//       const referenceElement = mobileFilterContainer.querySelector(
//         'details[data-index="mobile-9"]'
//       );

//       if (referenceElement) {
//         let additionalFiltersLabel = document.querySelector(
//           "#additional-filters-label"
//         );

//         if (!additionalFiltersLabel) {
//           additionalFiltersLabel = document.createElement("div");
//           additionalFiltersLabel.setAttribute("id", "additional-filters-label");

//           additionalFiltersLabel.setAttribute(
//             "class",
//             "mobile-facets__summary focus-inset"
//           );

//           additionalFiltersLabel.style.display = "flex";
//           additionalFiltersLabel.style.alignItems = "center";
//           additionalFiltersLabel.style.justifyContent = "space-between";
//           additionalFiltersLabel.style.padding = "13px 15px 13px 25px";
//           additionalFiltersLabel.style.cursor = "pointer";

//           // Create label text
//           const labelText = document.createElement("span");
//           labelText.innerText = "Additional Items";

//           // Create icon container
//           const iconContainer = document.createElement("span");
//           iconContainer.setAttribute("class", "mobile-facets__icon-container");
//           iconContainer.style.marginLeft = "8px";

//           // Create smaller SVG icon
//           const svgCaret = document.createElementNS(
//             "http://www.w3.org/2000/svg",
//             "svg"
//           );
//           svgCaret.setAttribute("class", "icon icon-caret");
//           svgCaret.setAttribute("viewBox", "0 0 10 6");
//           svgCaret.setAttribute("width", "10");
//           svgCaret.setAttribute("height", "10");

//           // Ensure icon rotates smoothly
//           svgCaret.style.transition = "transform 0.3s ease";

//           // Create path inside the SVG
//           const path = document.createElementNS(
//             "http://www.w3.org/2000/svg",
//             "path"
//           );
//           path.setAttribute("fill", "currentColor");
//           path.setAttribute("fill-rule", "evenodd");
//           path.setAttribute(
//             "d",
//             "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
//           );
//           path.setAttribute("clip-rule", "evenodd");

//           svgCaret.appendChild(path);
//           iconContainer.appendChild(svgCaret);

//           additionalFiltersLabel.appendChild(labelText);
//           additionalFiltersLabel.appendChild(iconContainer);
//         }

//         referenceElement.parentNode.insertBefore(
//           additionalFiltersLabel,
//           referenceElement.nextSibling
//         );

//         openMobileFacets.forEach((element) => {
//           element.style.display = "none";
//         });

//         let isFiltersVisible = false;
//         additionalFiltersLabel.addEventListener("click", () => {
//           isFiltersVisible = !isFiltersVisible;

//           openMobileFacets.forEach((element) => {
//             element.style.display = isFiltersVisible ? "block" : "none";
//           });

//           console.log("Toggling filters:", isFiltersVisible);

//           // Ensure rotation effect is applied correctly
//           const svgCaret = additionalFiltersLabel.querySelector(".icon-caret");
//           if (svgCaret) {
//             svgCaret.style.transform = isFiltersVisible
//               ? "rotate(180deg)" // Rotate upside down
//               : "rotate(0deg)"; // Default position
//           }
//         });

//         openMobileFacets.forEach((element) => {
//           additionalFiltersLabel.parentNode.insertBefore(
//             element,
//             additionalFiltersLabel.nextSibling
//           );
//         });
//       }
//     }
//   }
// }
function handleMobileFacets() {
  console.log("Running handleMobileFacets");

  const mobileFilterContainer = document.querySelector("#FacetsWrapperMobile");
  if (!mobileFilterContainer) return;

  const openMobileFacets = document.querySelectorAll(
    '.mobile-facets__details[open="true"]'
  );
  console.log("Found open mobile facets:", openMobileFacets.length);

  const referenceElement = mobileFilterContainer.querySelector(
    'details[data-index="mobile-9"]'
  );

  if (!referenceElement) return;

  let additionalFiltersLabel = document.querySelector(
    "#additional-filters-label"
  );

  if (!additionalFiltersLabel) {
    additionalFiltersLabel = document.createElement("div");
    additionalFiltersLabel.setAttribute("id", "additional-filters-label");
    additionalFiltersLabel.setAttribute(
      "class",
      "mobile-facets__summary focus-inset"
    );

    additionalFiltersLabel.style.display = "flex";
    additionalFiltersLabel.style.alignItems = "center";
    additionalFiltersLabel.style.justifyContent = "space-between";
    additionalFiltersLabel.style.padding = "13px 15px 13px 25px";
    additionalFiltersLabel.style.cursor = "pointer";

    // Create label text
    const labelText = document.createElement("span");
    labelText.innerText = "Additional Items";

    // Create icon container
    const iconContainer = document.createElement("span");
    iconContainer.setAttribute("class", "mobile-facets__icon-container");
    iconContainer.style.marginLeft = "8px";

    // Create smaller SVG icon
    const svgCaret = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    svgCaret.setAttribute("class", "icon icon-caret");
    svgCaret.setAttribute("viewBox", "0 0 10 6");
    svgCaret.setAttribute("width", "10");
    svgCaret.setAttribute("height", "10");

    // Ensure icon rotates smoothly
    svgCaret.style.transition = "transform 0.3s ease";

    // Create path inside the SVG
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("fill", "currentColor");
    path.setAttribute("fill-rule", "evenodd");
    path.setAttribute(
      "d",
      "M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
    );
    path.setAttribute("clip-rule", "evenodd");

    svgCaret.appendChild(path);
    iconContainer.appendChild(svgCaret);

    additionalFiltersLabel.appendChild(labelText);
    additionalFiltersLabel.appendChild(iconContainer);
  }

  referenceElement.parentNode.insertBefore(
    additionalFiltersLabel,
    referenceElement.nextSibling
  );

  openMobileFacets.forEach((element) => {
    element.style.display = "none";
  });

  let isFiltersVisible = false;
  additionalFiltersLabel.addEventListener("click", () => {
    isFiltersVisible = !isFiltersVisible;

    openMobileFacets.forEach((element) => {
      element.style.display = isFiltersVisible ? "block" : "none";
    });

    console.log("Toggling filters:", isFiltersVisible);

    // Rotate the icon only when clicking the label
    const svgCaret = additionalFiltersLabel.querySelector(".icon-caret");
    if (svgCaret) {
      svgCaret.style.transform = isFiltersVisible
        ? "rotate(180deg)"
        : "rotate(0deg)";
    }
  });

  openMobileFacets.forEach((element) => {
    additionalFiltersLabel.parentNode.insertBefore(
      element,
      additionalFiltersLabel.nextSibling
    );
  });

  // **NEW FIX**: Reset icon when filters panel is reopened
  const mobileFilterPanel = document.querySelector(".mobile-facets");
  if (mobileFilterPanel) {
    mobileFilterPanel.addEventListener("click", () => {
      if (!isFiltersVisible) {
        const svgCaret = additionalFiltersLabel.querySelector(".icon-caret");
        if (svgCaret) {
          svgCaret.style.transform = "rotate(0deg)";
        }
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  handleDesktopFacets();
  handleMobileFacets();
});

document.addEventListener("click", function (event) {
  if (event.target.closest(".mobile-facets__open-wrapper.focus-offset")) {
    mobileprocessFacets();
    handleMobileFacets();
  }
});
// (function () {
//     let oldHref = location.href;

//     const observer = new MutationObserver(() => {
//         if (oldHref !== location.href) {
//             handleDesktopFacets();
//             handleMobileFacets();
//             oldHref = location.href;
//         }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });

// })();
